import { render, staticRenderFns } from "./CourseGroupNew.vue?vue&type=template&id=302371fc"
import script from "./CourseGroupNew.vue?vue&type=script&lang=js"
export * from "./CourseGroupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports